import FlexView from "react-flexview";
import SimpleDDL from "../../../modules/SimpleDDL";
import React from "react";
import Button from "../../../modules/commons/Button";
import SimpleInput from "../../../modules/SimpleInput";
import { mapToObjectDDL } from "../../common/mapper";

export const tableConfig = [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        return page * rowsPerPage + tableMeta.rowIndex + 1;
      },
      setCellProps: () => ({
        style: { width: "5%" },
      }),
    },
  },
  {
    name: "documentId",
    label: "ID Dokumen",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "35%" },
      }),
    },
  },
  {
    name: "wilayah",
    label: "Nama Wilayah",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "35%" },
      }),
    },
  },
];

export const INITIAL_VALUE_STOCK_UNIT = {
  unitStockId: null,
  kodeVariant: null,
  namaVariant: null,
  namaWarna: null,
  kodeWarna: null,
  stockDays: null,
  isSaved: false,
};

export const INITIAL_VALUE_STOCK_PART = {
  partStockId: null,
  partCode: null,
  namaPart: null,
  stockDays: null,
  isSaved: false,
};

export const tableStockConfig = {
  unit: (params) => [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (value, tableMeta) => {
                return <>{tableMeta.rowIndex + 1}</>;
            },
            sort: false,
        },
    },
    {
      name: "unitStockId",
      label: "ID",
      options: {
        sort: false,
      },
    },
    {
      name: "kodeVariant",
      label: (
        <>
          Kode Varian <span style={{ color: "red" }}>*</span>
        </>
      ),
      options: {
        sort: false,
        customBodyRender: (val, { rowIndex }) => {
          const isSaved = params.dataTable[rowIndex].isSaved;
          const options = params.variantOptions.map((item) =>
            mapToObjectDDL(item.kodeVariant, item.kodeVariant)
          );
          return (
            <SimpleDDL
              isClearable
              containerclassname="margin margin-top-15px"
              errorMessage={params.errors?.unit?.[rowIndex]?.kodeVariant}
              showErrorWithoutMandatory
              id="variant_options"
              box="search"
              name="kodeVariant"
              options={options}
              value={val}
              readOnly={isSaved}
              onChange={(value) =>
                params.handleKodeVarianChange(rowIndex, "kodeVariant", value)
              }
            />
          );
        },
      },
    },
    {
      name: "namaVariant",
      label: (
        <>
          Nama Varian <span style={{ color: "red" }}>*</span>
        </>
      ),
      options: {
        sort: false,
        setCellProps: () => ({
          style: { width: "20%" },
        }),
        customBodyRender: (val, { rowIndex }) => {
          const isSaved = params.dataTable[rowIndex].isSaved;
          const options = params.variantOptions.map((item) =>
            mapToObjectDDL(item.namaVariant, item.kodeVariant)
          );
          return (
            <SimpleDDL
              isClearable
              showErrorWithoutMandatory
              containerclassname="margin margin-top-15px"
              errorMessage={params.errors?.unit?.[rowIndex]?.namaVariant}
              id="nama_variant_options"
              box="search"
              name="namaVariant"
              options={options}
              value={val}
              readOnly={isSaved}
              onChange={(value) =>
                params.handleNamaVarianChange(rowIndex, "namaVariant", value)
              }
            />
          );
        },
      },
    },
    {
      name: "kodeWarna",
      label: (
        <>
          Kode Warna <span style={{ color: "red" }}>*</span>
        </>
      ),
      options: {
        sort: false,
        customBodyRender: (val, { rowIndex }) => {
          const isSaved = params.dataTable[rowIndex].isSaved;
          const options = params.warnaOptions.map((item) =>
            mapToObjectDDL(item.kodeWarna, item.id)
          );
          const kodeVarian = params.dataTable[rowIndex]?.kodeVariant?.value;
          return (
            <SimpleDDL
              isClearable
              showErrorWithoutMandatory
              containerclassname="margin margin-top-15px"
              errorMessage={params.errors?.unit?.[rowIndex]?.kodeWarna}
              id="kode_warna_options"
              box="search"
              name="kodeWarna"
              onMenu
              options={options}
              value={val}
              onMenuOpen={() => params.fetchDataWarna(kodeVarian)}
              readOnly={isSaved}
              onChange={(value) =>
                params.handleKodeWarnaChange(rowIndex, "kodeWarna", value)
              }
            />
          );
        },
      },
    },
    {
      name: "namaWarna",
      label: (
        <>
          Kode Warna <span style={{ color: "red" }}>*</span>
        </>
      ),
      options: {
        sort: false,
        setCellProps: () => ({
          style: { width: "20%" },
        }),
        customBodyRender: (val, { rowIndex }) => {
          const isSaved = params.dataTable[rowIndex].isSaved;
          const options = params.warnaOptions.map((item) =>
            mapToObjectDDL(item.namaWarnaPabrik, item.id)
          );
          const kodeVarian = params.dataTable[rowIndex]?.kodeVariant?.value;
          return (
            <SimpleDDL
              isClearable
              showErrorWithoutMandatory
              containerclassname="margin margin-top-15px"
              errorMessage={params.errors?.unit?.[rowIndex]?.namaWarna}
              onMenuOpen={() => params.fetchDataWarna(kodeVarian)}
              id="kode_warna_options"
              box="search"
              name="namaWarna"
              options={options}
              value={val}
              readOnly={isSaved}
              onChange={(value) =>
                params.handleNamaWarnaChange(rowIndex, "namaWarna", value)
              }
            />
          );
        },
      },
    },
    {
      name: "stockDays",
      label: (
        <>
          Acuan Stock (Days) <span style={{ color: "red" }}>*</span>
        </>
      ),
      options: {
        sort: false,
        setCellProps: () => ({
          style: { width: "8%" },
        }),
        customBodyRender: (val, { rowIndex }) => {
          const isSaved = params.dataTable[rowIndex].isSaved;
          return (
            <SimpleInput
              containerclassname="margin margin-top-15px"
              showErrorWithoutMandatory
              errorMessage={params.errors?.unit?.[rowIndex]?.stockDays}
              id="input_acuan_stock"
              box="onlyNumber"
              name="stockDays"
              value={val}
              readOnly={isSaved}
              onChange={({ target }) =>
                params.handleValueChange(
                  rowIndex,
                  target.name,
                  Number(target.value)
                )
              }
            />
          );
        },
      },
    },
    {
      name: "",
      label: "Aksi",
      options: {
        sort: false,
        customBodyRender: (_, { rowIndex }) => {
          const color = params.isReadonly ? "color-grey" : "color-red";
          return (
            <FlexView vAlignContent="center" style={{ gap: "12px" }}>
              {params.dataTable[rowIndex]?.isSaved ? (
                <Button
                  className="btnAct background-transparent txt-site txt-title"
                  type="button"
                  disabled={params.isReadonly}
                  onClick={() => params.toggleCorrection(rowIndex, true)}
                >
                  <i className={`fa fa-pencil-alt ${color}`} />
                </Button>
              ) : (
                <Button
                  className="btnAct background-transparent txt-site txt-title"
                  type="button"
                  disabled={params.isReadonly}
                  onClick={() => params.onSaveCorrection(rowIndex, false)}
                >
                  <i className={`fa fa-save color-red`} />
                </Button>
              )}
              <Button
                className="btnAct background-transparent txt-site txt-title"
                type="button"
                disabled={params.isReadonly}
                onClick={() => params.handleDelete(rowIndex)}
              >
                <i className={`fa fa-trash ${color}`} />
              </Button>
            </FlexView>
          );
        },
      },
    },
  ],
  part: (params) => [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (value, tableMeta) => {
                return <>{tableMeta.rowIndex + 1}</>;
            },
            sort: false,
        },
    },
    {
      name: "partStockId",
      label: "ID",
      options: {
        sort: false,
        setCellProps: () => ({
          style: { width: "20%"},
        }),
      },
    },
    {
      name: "namaPart",
      label: (
        <>
          Nama Part <span style={{ color: "red" }}>*</span>
        </>
      ),
      options: {
        sort: false,
        setCellProps: () => ({
          style: { width: "30%" },
        }),
        customBodyRender: (val, { rowIndex }) => {
          const data = params.dataTable[rowIndex];
          const isSaved = data.isSaved;
          const options = params?.partOptions?.map((item) =>
            mapToObjectDDL(item?.partName, item?.kodePart)
          );
          return (
            <SimpleDDL
              isClearable
              showErrorWithoutMandatory
              containerclassname="margin margin-top-15px"
              errorMessage={params.errors?.part?.[rowIndex]?.namaPart}
              id="variant_options"
              box="search"
              name="namaPart"
              options={options}
              value={val}
              readOnly={isSaved}
              onChange={(value) =>
                params.handleNamaPartChange(rowIndex, "namaPart", value)
              }
            />
          );
        },
      },
    },
    {
      name: "partCode",
      label: (
        <>
          Kode Part <span style={{ color: "red" }}>*</span>
        </>
      ),
      options: {
        sort: false,
        setCellProps: () => ({
          style: { width: "30%" },
        }),
        customBodyRender: (val, { rowIndex }) => {
          const isSaved = params.dataTable[rowIndex].isSaved;
          const options = params.partOptions?.map((item) =>
            mapToObjectDDL(item.kodePart, item.kodePart)
          );
          return (
            <SimpleDDL
              isClearable
              showErrorWithoutMandatory
              containerclassname="margin margin-top-15px"
              errorMessage={params.errors?.part?.[rowIndex]?.partCode}
              id="nama_variant_options"
              box="search"
              name="partCode"
              options={options}
              value={val}
              readOnly={isSaved}
              onChange={(value) =>
                params.handleKodePartChange(rowIndex, "partCode", value)
              }
            />
          );
        },
      },
    },
    {
      name: "stockDays",
      label: (
        <>
          Acuan Stock (Days) <span style={{ color: "red" }}>*</span>
        </>
      ),
      options: {
        sort: false,
        setCellProps: () => ({
          style: { width: "10%" },
        }),
        customBodyRender: (val, { rowIndex }) => {
          const isSaved = params.dataTable[rowIndex].isSaved;
          return (
            <SimpleInput
              showErrorWithoutMandatory
              containerclassname="margin margin-top-15px"
              errorMessage={params.errors?.part?.[rowIndex]?.stockDays}
              id="input_acuan_stock"
              box="onlyNumber"
              name="stockDays"
              value={val}
              readOnly={isSaved}
              onChange={({ target }) =>
                params.handleValueChange(
                  rowIndex,
                  target.name,
                  Number(target.value)
                )
              }
            />
          );
        },
      },
    },
    {
      name: "",
      label: "Aksi",
      options: {
        sort: false,
        customBodyRender: (_, { rowIndex }) => {
          const color = params.isReadonly ? "color-grey" : "color-red";
          return (
            <FlexView vAlignContent="center" style={{ gap: "12px" }}>
              {params.dataTable[rowIndex]?.isSaved ? (
                <Button
                  className="btnAct background-transparent txt-site txt-title"
                  type="button"
                  disabled={params.isReadonly}
                  onClick={() => params.toggleCorrection(rowIndex, true)}
                >
                  <i className={`fa fa-pencil-alt ${color}`} />
                </Button>
              ) : (
                <Button
                  className="btnAct background-transparent txt-site txt-title"
                  type="button"
                  disabled={params.isReadonly}
                  onClick={() => params.onSaveCorrection(rowIndex, false)}
                >
                  <i className={`fa fa-save color-red`} />
                </Button>
              )}
              <Button
                className="btnAct background-transparent txt-site txt-title"
                type="button"
                disabled={params.isReadonly}
                onClick={() => params.handleDelete(rowIndex)}
              >
                <i className={`fa fa-trash ${color}`} />
              </Button>
            </FlexView>
          );
        },
      },
    },
  ],
};
